// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__OEeE6","title":"Info_title__2-5Pj","links":"Info_links__2ZRHm","link":"Info_link__3NgVO","logo":"Info_logo__wXGbj"};